// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import AccordionState from '../../../../shared/components/smart-accordion/state/accordion';
import ReportLinks from '../../../../shared/components/report-links';
import {secure} from '../../../../shared/components/security-wrapper/secure';

const ProductReportLinks = props =>
    <ReportLinks
        accordion={props.reportsAccordion}
        onAccordionToggle={props.onAccordionToggle}
        parentRoute='products'
        routes={props.reportsRoutes}
    />;

ProductReportLinks.displayName = 'ProductReportLinks';
ProductReportLinks.propTypes = {
    onAccordionToggle: PropTypes.func.isRequired,
    reportsAccordion: PropTypes.instanceOf(AccordionState).isRequired,
    reportsRoutes: PropTypes.object.isRequired
};

export default secure('PRT', 'PRT_REPORTS')(ProductReportLinks);



// WEBPACK FOOTER //
// ./src/product/shared/components/product-report-links/index.js